
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginWithEmailPassword } from '@/services/auth/authService';
import { extractUserInfo } from '@/utils/firebase';
import { useUserOperations } from '@/context/schema/useUserOperations'; // Changed import
import { MemberRole, MemberStatus } from '@/types/schema';
import { z } from 'zod';

export const useLoginForm = (savedEditPath: string | null, fromPath: string) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { updateUser } = useUserOperations(null); // Changed to useUserOperations and updateUser, passed null

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await loginWithEmailPassword(email, password);
      if (result.success && result.user) {
        const userInfo = extractUserInfo(result.user);
        
        const roleValidation = z.enum(['Primary Owner', 'Owner', 'Manager']).safeParse(userInfo.role);
        const role = roleValidation.success ? roleValidation.data as MemberRole : 'Manager' as MemberRole;
        
        // Changed to updateUser and passed result.user.uid as the first argument
        updateUser(result.user.uid, { 
          ...userInfo,
          role, // Explicitly set role here
          status: 'active' as MemberStatus
        });
        
        // Log successful login and navigation target
        console.log('Login successful, navigating to:', fromPath);
        
        // Clear session storage when we use it
        if (savedEditPath) {
          sessionStorage.removeItem('returnToEditPage');
        }
        
        // Navigate to the path user was trying to access
        navigate(fromPath, { replace: true });
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err: any) {
      setError(err.message || 'An error occurred');
    }

    setIsLoading(false);
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    isLoading,
    error,
    handleSubmit
  };
};
